
/* --------------- fade in anime --------------- */
window.addEventListener('DOMContentLoaded', function() {
  const fadeinElements = document.querySelectorAll('.fade-in');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  fadeinElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
			setTimeout(function() {
      	element.classList.add('scrollin');
			}, 500);
    }
  });
  const scrollElements = document.querySelectorAll('.scroll_anime');

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });
});

window.addEventListener('scroll', function() {
  const scrollElements = document.querySelectorAll('.scroll_anime');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
	
	/* --------------- youtube-thumbnail --------------- */
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


	function videoControl(action) {
		const playerWindow = $("#player")[0].contentWindow;
		playerWindow.postMessage(
			'{"event":"command","func":"' + action + '","args":""}',
			"*"
		);
	}

	document.querySelectorAll('.thumbnail').forEach(function(thumbnail) {
		thumbnail.addEventListener('click', function() {
			// クリックされた要素をフェードアウトする
			this.style.transition = 'opacity 0.9s'; // フェードアウトのアニメーションを設定
			this.style.opacity = 0; // 透明にする
			this.style.zIndex = 0; // 透明にする

			// videoControl関数を呼び出し
			videoControl('playVideo');
		});
	});


	/* --------------- swiper --------------- */

	const middleSlide = new Swiper('.slider01', {
		loop: true,
		speed: 500,
		slidesPerView: 1,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});
	
	const bottomSlide = new Swiper('.slider02', {
		loop: true,
		speed: 500,
		slidesPerView: 1.22,
		spaceBetween: 52,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		breakpoints: {
			750: {
				slidesPerView: 1.85,
			}, 
			980: {
				slidesPerView: 2.22,
			}
		},
	});

	const carousel = new Swiper('.carousel', {
		loop: true,
		speed: 500,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		slidesPerView: "auto",
		autoplay: {
			delay: 3000,
			disableOnInteraction: false, 
		},
		breakpoints: {
			750: {
				slidesPerView: "auto",
				centeredSlides: false,
			}, 
			980: {
				slidesPerView: "auto",
				centeredSlides: false,
			},
		},
	});

});
